// 一覧表示系のページで使用する処理をまとめたもの
// mixinの挙動は継承ではなくマージなので留意すること

import Search from '@/utility/WordSearch'

const list = {
  data: function() {
    return {
      fetchItems: [], // storeから取得したデータ
      allItems: [], // 表示対象となるデータ。基本的に上記と同様だが絞り込みをすると変更される
      displayItemPerPageCount: 500, // 1ページに表示する行数
      totalItemCount: 0, // 表示対象となるデータの件数
      currentPage: 1, // 現在のページ
      displayItems: [], // 現在の画面に表示するデータ
      searchString: '', // 検索に仕様する文字列
    }
  },
  methods: {
    /*
      1ページあたりの表示件数を変更する
      変更後、変更した数値に応じて画面に表示する内容を変える
    */
    changeRowPerPageCount: function(count) {
      this.currentPage = 1
      this.displayItemPerPageCount = count
      if (this.currentPage === 1) {
        this.displayItems = this.allItems.slice(0, count)
      } else {
        const items = this.allItems.slice(count)
        if (items.length === this.count) {
          this.displayItems = items
        } else {
          this.displayItems = items.slice(0, items.length)
        }
      }
    },
    /*
      現在のページを変更する（ページ送り処理）
    */
    changePage: function(page) {
      this.currentPage = page
    },
    searchWord: function() {
      // 2文字入力されるまでは検索しない
      if (this.searchString.length < 2) {
        this.allItems = this.fetchItems
      } else {
        this.allItems = Search.searchFromCollection(
          this.fetchItems,
          this.searchString.toLowerCase()
        )
      }
    },
    getDisplayItems() {
      return this.allItems.slice(
        this.displayItemPerPageCount * (this.currentPage - 1),
        this.displayItemPerPageCount * this.currentPage
      )
    },
  },
  watch: {
    currentPage: function() {
      this.displayItems = this.getDisplayItems()
    },
    allItems: function() {
      this.currentPage = 1
      this.totalItemCount = this.allItems.length
      this.displayItems = this.getDisplayItems()
    },
  },
}

export default list
